import { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const SearchBar = ({ onSearch, onFilterChange, resultsCount }) => {
  const [keyword, setKeyword] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCity, setSelectedCity] = useState('');

  const categories = [
    { value: '', label: 'Todas las categorías' },
    { value: 'restaurantes', label: 'Restaurantes' },
    { value: 'moda', label: 'Moda y Accesorios' },
    { value: 'tecnologia', label: 'Tecnología' },
    { value: 'salud', label: 'Salud y Belleza' },
    { value: 'hogar', label: 'Hogar y Decoración' },
    { value: 'deportes', label: 'Deportes y Fitness' },
    { value: 'educacion', label: 'Educación' },
    { value: 'entretenimiento', label: 'Entretenimiento' },
    { value: 'servicios', label: 'Servicios Profesionales' },
    { value: 'automotriz', label: 'Automotriz' }
  ];

  const cities = [
    { value: '', label: 'Todas las ciudades' },
    { value: 'pasto', label: 'Pasto' },
    { value: 'bogota', label: 'Bogotá' },
    { value: 'medellin', label: 'Medellín' },
    { value: 'cali', label: 'Cali' },
    { value: 'barranquilla', label: 'Barranquilla' },
    { value: 'cartagena', label: 'Cartagena' },
    { value: 'cucuta', label: 'Cúcuta' },
    { value: 'bucaramanga', label: 'Bucaramanga' },
    { value: 'pereira', label: 'Pereira' },
    { value: 'manizales', label: 'Manizales' }
  ];

  const handleSearch = () => {
    onSearch({ keyword, category: selectedCategory, city: selectedCity });
  };

  const handleClearFilters = () => {
    setKeyword('');
    setSelectedCategory('');
    setSelectedCity('');
    onFilterChange({ keyword: '', category: '', city: '' });
  };

  const handleKeywordChange = (e) => {
    const value = e?.target?.value;
    setKeyword(value);
    onFilterChange({ keyword: value, category: selectedCategory, city: selectedCity });
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    onFilterChange({ keyword, category: value, city: selectedCity });
  };

  const handleCityChange = (value) => {
    setSelectedCity(value);
    onFilterChange({ keyword, category: selectedCategory, city: value });
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-card mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-foreground">Buscar Negocios</h2>
        {resultsCount !== null && (
          <span className="text-sm text-muted-foreground">
            {resultsCount} {resultsCount === 1 ? 'resultado' : 'resultados'}
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <Input
          type="search"
          placeholder="Buscar por nombre o palabra clave..."
          value={keyword}
          onChange={handleKeywordChange}
          className="col-span-1 md:col-span-3"
        />

        <Select
          placeholder="Seleccionar categoría"
          options={categories}
          value={selectedCategory}
          onChange={handleCategoryChange}
          searchable
        />

        <Select
          placeholder="Seleccionar ciudad"
          options={cities}
          value={selectedCity}
          onChange={handleCityChange}
          searchable
        />

        <div className="flex gap-2">
          <Button
            variant="default"
            onClick={handleSearch}
            iconName="Search"
            iconPosition="left"
            fullWidth
          >
            Buscar
          </Button>
          <Button
            variant="outline"
            onClick={handleClearFilters}
            iconName="X"
            size="icon"
          >
            <span className="sr-only">Limpiar filtros</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;